import React, { memo, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-final-form";
import useNotification from "notification";
import _ from "lodash";

import { useAppContext } from "app/AppContext";

import "./style.css";
import { Box, Button, CircularProgress, MenuItem, Paper, Typography } from "@mui/material";

import { imprimirListaPresenca, produtosSugeridosCSV } from "entity/Rodada/functions";
import TabPanel from "components/tabs/TabPanel";
import TabContainer from "components/tabs/TabContainer";
import DefaultEntityCrud from "components/form/DefaultEntityCrud";
import FormContent from "components/form/FormContent";
import DropDownButton from "components/DropDownButton";
import RodadaEntity from "entity/Rodada";
import Reuniao from "entity/Reuniao";
import Catalogo from "./Catalogo";

import PainelDeReunioes from "./PainelDeReunioes";

import CardTabs from "./CardTabs";

import { useIsAdmin, useUserUid } from "useAuth";

import PainelTodosInscritos from "./components/PainelTodosInscritos";
import PainelInscritosAncoras from "./components/PainelInscritosAncoras";
import PainelInscritosFlutuantes from "./components/PainelInscritosFlutuantes";
import TabelaReunioes from "./components/TabelaReunioes";
import { PainelProvider, usePainelContext } from "./PainelContext";
import CopiarInscritosDialog from "../CopiarInscritosDialog";
const ButtonsImprimir = ({ rodada }) => {
    const { inscricoes } = usePainelContext();

    return (
        <>
            <MenuItem onClick={() => produtosSugeridosCSV(inscricoes, rodada)}>{"Produtos Sugeridos (.xlsx)"}</MenuItem>
            <MenuItem onClick={() => imprimirListaPresenca(inscricoes, rodada)}>Lista de Presença</MenuItem>
        </>
    );
};
const ContentePainelReunioes = ({ rodada }) => {
    const { showSuccess } = useNotification();
    const { inscricoes, reunioes } = usePainelContext();

    return (
        <PainelDeReunioes
            rodada={rodada}
            inscricoes={inscricoes}
            reunioes={reunioes}
            deleteOnCard={(r) => {
                let auxR = r;
                auxR.status = "INATIVO";

                let entity = new Reuniao();
                entity.update(auxR);
                entity.save().then(() => {
                    showSuccess("Reunião salva com Sucesso");
                });
            }}
        />
    );
};

const PainelControleInter = memo(function PainelControleInter(props) {
    // console.log("PainelControleInter");
    const [openCatalogo, setOpenCatalogo] = useState(false);
    const [openCopiarInscritos, setOpenCopiarInscritos] = useState(false);
    const { startListnersRodada } = usePainelContext();
    const navigate = useNavigate();
    const form = useForm();

    const [searchParams] = useSearchParams();
    const searchRodada = searchParams.get("rodada");

    const [rodada, setRodada] = useState();
    // const [inscricoes, setInscricoes] = useState([]);
    // const [reunioes, setReunioes] = useState([]);

    const { statusEventoFiltroAncora, statusEventoFiltroFornecedor, statusEventoFiltroParticipante } = props.values;

    const [tab, setTab] = useState(0);
    const [tabR, setTabR] = useState(0);
    const { showSuccess } = useNotification();

    const { useSetTitle } = useAppContext();

    const isAdmin = useIsAdmin();

    const currentUserUID = useUserUid();

    useSetTitle(rodada ? "Painel de Controle - " + rodada.nome : "Painel de Controle");

    //START
    useEffect(() => {
        let observer = null;
        let observers = [];
        console.log("useEffect RodadaEntity searchRodada", searchRodada);
        if (!rodada) {
            observer = RodadaEntity.onSnapshot(searchRodada, (r) => {
                setRodada(r);
                observers = startListnersRodada(r);
            });
        }

        if (!statusEventoFiltroParticipante) {
            form.change("statusEventoFiltroParticipante", "TODOS");
        }
        if (!statusEventoFiltroFornecedor) {
            form.change("statusEventoFiltroFornecedor", "TODOS");
        }
        if (!statusEventoFiltroAncora) {
            form.change("statusEventoFiltroAncora", "TODOS");
        }

        return () => {
            if (observer) observer();
            observers.forEach((o) => {
                if (o) o();
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FormContent sx={{ m: 1 }}>
            {rodada ? (
                isAdmin ||

                    (rodada.perfisAutorizado &&
                        Object.keys(rodada.perfisAutorizado).length &&
                        _.get(rodada.perfisAutorizado, currentUserUID)) ? (
                    <Paper elevation={3} sx={{ flex: 1 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: 2, gap: 1, flexWrap: "wrap" }}>
                            <Typography style={{ flex: 1 }} variant="h6">
                                {rodada.nome}
                            </Typography>

                            <Catalogo
                                rodada={rodada}
                                // participantes={inscricoes}
                                open={openCatalogo}
                                setOpen={setOpenCatalogo}
                            />

                            <Button
                                style={{ width: 150 }}
                                onClick={() => {
                                    window.open(`/#/realtime?rodada=${rodada.uid}`, "_blank");
                                }}
                            >
                                Rodada em Tempo Real
                            </Button>

                            <DropDownButton label="Outras Ações" style={{ width: 150, height: "100%" }}>

                                <MenuItem
                                    onClick={() => {
                                        navigate(`/rodada?uid=${rodada.uid}`);
                                    }}
                                >
                                    Editar Rodada
                                </MenuItem>

                                <MenuItem
                                    onClick={() => {
                                        navigate(`/etiquetaAvulsa?rodada=${rodada.nome}&uid=${rodada.uid}`);
                                    }}
                                >
                                    Etiqueta Avulsa
                                </MenuItem>
                                {/* <MenuItem
                                    onClick={() => {
                                        navigate(`/assistente-reuniao?rodada=${searchRodada}`);
                                    }}
                                >
                                    Assistente de Agendamentos
                                </MenuItem> */}
                                <MenuItem
                                    onClick={() => {
                                        navigate(`/assistente-reuniao2?rodada=${searchRodada}`);
                                    }}
                                >
                                    Assistente de Agendamentos
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        // abrir em outra aba
                                        window.open(
                                            `${window.location.origin}/#/public-inscricao?rodada=${searchRodada}&type=2&painel=1`,
                                            "_blank"
                                        );
                                        // abrir na mesma aba
                                        // navigate(`/public-inscricao?rodada=${searchRodada}&type=2`)
                                    }}
                                >
                                    Abrir Link de Inscrição
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        // abrir em outra aba
                                        window.open(
                                            `${window.location.origin}/#/inscrever-se?rodada=${searchRodada}`,
                                            "_blank"
                                        );
                                        // abrir na mesma aba
                                        // navigate(`/public-inscricao?rodada=${searchRodada}&type=2`)
                                    }}
                                >
                                    Abrir Link de Inscrição Simplificado
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        // copiar o link
                                        navigator.clipboard.writeText(
                                            `${window.location.origin}/#/public-inscricao?rodada=${searchRodada}&type=2`
                                        );
                                        showSuccess("Link Copiado");
                                    }}
                                >
                                    Copiar Link de Inscrição
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setOpenCopiarInscritos(true);
                                    }}
                                >
                                    Importar Inscritos
                                </MenuItem>
                                <ButtonsImprimir rodada={rodada} />
                            </DropDownButton>

                            <CopiarInscritosDialog
                                rodadaDestino={rodada}
                                open={openCopiarInscritos}
                                onClose={() => setOpenCopiarInscritos(false)}
                            />
                        </Box>
                        <CardTabs tab={tab} setTab={setTab} rodada={rodada} />
                        <TabContainer tab={tab} changeTab={setTab} hidetabs={true}>
                            <TabPanel label="TODOS" sx={{ m: 1 }}>
                                <PainelTodosInscritos rodada={rodada} />
                            </TabPanel>

                            <TabPanel label="Âncoras" sx={{ m: 1 }}>
                                <PainelInscritosAncoras rodada={rodada} />
                            </TabPanel>

                            <TabPanel label="Fornecedores" sx={{ m: 1 }}>
                                <PainelInscritosFlutuantes rodada={rodada} />
                            </TabPanel>

                            <TabPanel label="Reuniões" sx={{ m: 1 }}>
                                <TabContainer tab={tabR} changeTab={setTabR}>
                                    <TabPanel label="Grade" sx={{ m: 1 }}>
                                        <ContentePainelReunioes rodada={rodada} />
                                    </TabPanel>
                                    <TabPanel label="Lista" sx={{ m: 1 }}>
                                        <TabelaReunioes rodada={rodada} />
                                    </TabPanel>
                                </TabContainer>
                            </TabPanel>
                        </TabContainer>
                    </Paper>
                ) : (
                    <Typography sx={{ display: "flex", justifyContent: "center", color: "text.disabled" }} variant="h6">
                        - SEM PERMISSÃO PARA ACESSAR ESSA RODADA -
                    </Typography>
                )
            ) : (
                <div
                    style={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 15,
                        gap: 10,
                    }}
                >
                    {" "}
                    <CircularProgress /> Carregando Rodada...
                </div>
            )}
        </FormContent>
    );
});

export default function PainelControle() {
    return (
        <DefaultEntityCrud
            EntityClass={RodadaEntity}
            title={"Painel de Controle"}
            routeForm="rodada"
            backRoute="consulta-rodada"
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
        >
            {(props) => {
                return (
                    <PainelProvider>
                        <PainelControleInter {...props} />
                    </PainelProvider>
                );
            }}
        </DefaultEntityCrud>
    );
}
